// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signaling-server[data-v-256bf8c2]{height:44px;display:flex;align-items:center}\n", ""]);
// Exports
module.exports = exports;
